import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import { bindViewport } from "./viewport";
import ViewportDebug from "./ViewportDebug";
// Initialize before React paints the first frame (including fresh browser tabs).
const releaseViewport = bindViewport();
if (import.meta.hot) import.meta.hot.dispose(releaseViewport);
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <ViewportDebug />
  </React.StrictMode>,
);
